module.exports = __webpack_public_path__ + "static/media/House Filter.00a47538.svg";